module.exports = __webpack_public_path__ + "static/media/img-carousel-landing-3.b27742d2.jpg";